export default {
  deactivateAndTransferNew: '0',
  deactivateAndTransferExist: '1',
  deactivate: '2',
  deactivateAndTransferAnother: '3',
};
